// Someone who signed up while connecting an app goes straight back to it, never through the dashboard and its upgrade prompts
export const continueAfterSignUp = (history, path) => {
  const redirectUrl = localStorage.getItem('redirect-url')
  if (!redirectUrl) {
    history.push(path)
    return
  }
  localStorage.removeItem('redirect-url')
  window.location = redirectUrl
}
